<div class="invoices-container">
  <app-invoices-add [invoices]="invoices"></app-invoices-add>
  <app-invoices-list></app-invoices-list>
</div>



// WEBPACK FOOTER //
// ./src/app/invoices/invoices.component.html